export default __webpack_public_path__ + "static/media/gonzo.e874335f.png";